export const BG_PRIMARY = '#FEFEFE';
export const BG_SECONDARY = 'rgba(211,227,243,1)';
export const BG_ALTERNATIVE = 'rgba(60,74,96,1)';

export const BG_STEP_RSVP = 'rgba(132,163,187,1)';

export const TEXT_PRIMARY = '#1A1B1D';
export const TEXT_SECONDARY = 'rgba(26,27,29,1)';
export const TEXT_ALTERNATIVE = '#FEFEFE';

export const NAVIGATION_ICON_COLOR = '#FFFFFF';

export const HASHTAG_STYLE = {
  fontFamily: 'body',
  fontWeight: 'light',
  fontSize: '26px',
  fontStyle: 'italic',
};

export const BUTTON_PROPS = {};

export const DEFAULT_BUTTON_PROPS = {
  fontWeight: 'light',
  size: 'sm',
  fontSize: 'xl',
  padding: '17px 40px',
  fontStyle: 'italic',
  type: 'button',
  bgColor: 'bgSecondary',
  color: 'secondaryColorText',
  fontFamily: 'body',
  borderRadius: '0',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: '#1A1B1D',
};
